module.exports = require("./fr-ML");